import { Injectable, OnDestroy } from '@angular/core';

import { merge, switchMap, take, tap } from 'rxjs';

import { WebSocketEventsEnum } from '@shared/websocket';
import { AuthUser } from '@shared/signup/models';
import { AudioService as CommonAudioService } from '@tablesready/common-ui';
import {
  AuthRestaurantService,
  SocketService,
} from '@tablesready/frontend-store';
import { LoggerService } from '@tablesready/frontend-logger';

@Injectable({ providedIn: 'root' })
export class AudioService extends CommonAudioService implements OnDestroy {
  private user: AuthUser = null;

  constructor(
    loggerService: LoggerService,
    private readonly socketService: SocketService,
    private readonly authRestaurantService: AuthRestaurantService,
  ) {
    super(loggerService);
  }

  init() {
    return this.authRestaurantService.select()
      .pipe(
        tap(user => this.user = user),
        take(1),
        switchMap(() => merge(
          this.socketService.getEventStream(WebSocketEventsEnum.InboundSmsEvent)
            .pipe(tap(() => this.inboundEvtHandler())),
          this.socketService.getEventStream(WebSocketEventsEnum.newPublicCheckInEvent)
            .pipe(tap(() => this.newPublicCheckInEvtHandler())),
        )),
      );
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  private inboundEvtHandler() {
    if (this.user?.alertsSettings?.arrivesSmsNotify.sound) {
      this.playSMSConfirmation();
    }
  }

  private newPublicCheckInEvtHandler() {
    if (this.user?.alertsSettings?.newPublicCheckInNotify.sound) {
      this.playCheckInConfirmation();
    }
  }
}
